import { Truck } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconTruck(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Truck />
    </IconWrapper>
  );
}
